import { render, staticRenderFns } from "./job.component.html?vue&type=template&id=244cb26a&scoped=true&external"
import script from "./job.component.ts?vue&type=script&lang=ts&external"
export * from "./job.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job.component.scss?vue&type=style&index=0&id=244cb26a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cb26a",
  null
  
)

export default component.exports